// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_6Zh","cls2":"AuthorHeader-cls2_Z6m AuthorHeader-cls1_6Zh"};